<template>
    <div class="container pt-6 pb-10">
        <div class="flex flex-col lg:flex-row justify-between items-center mb-6">
            <h1 class="page-title">Kit gard</h1>
        </div>
        <FenceMaterialsBill :fence="fenceModules" />
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FenceMaterialsBill from './FenceMaterialsBill.vue';

export default {
    name: 'FenceMaterials',
    components: {
        FenceMaterialsBill
    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            // Local state can be added here if needed
        };
    },
    computed: {
        ...mapState('fenceMaterials', ['fenceModules']),
    },
    methods: {
        ...mapActions('fenceMaterials', ['fetchFenceModules']),
        // Methods can be added here if needed
    },
    created() {
        this.fetchFenceModules(this.id);
    }
}
</script>